export const STRUCTURE_GRID_ZONE_OUTLINES_Z_CLASS = 'z-[16]';
export const STRUCTURE_GRID_LINESET_LINES_Z_CLASS = 'z-[18]';
export const STRUCTURE_GRID_LINESET_POINTS_Z_CLASS = 'z-[19]';
export const STRUCTURE_GRID_LINESET_TRANSITIONS_Z_CLASS = 'z-[20]';
